<template>
  <page-outline :title="$t('Webheader.RSVcreneau')">
    <template slot="pageContent">
      <hr class="mx-auto" />
      <div class="container">
        <div v-if="hasValidCurrentSession" class="current-session-message">
          {{ $t('calendar.message_current_session') }}
        </div>
        <!-- Navigation du calendrier -->
        <div class="calendar-navigation">
          <button @click="previousYear">&#x3C;</button>
          <span class="calendar-year">{{ currentYear }}</span>
          <button @click="nextYear">&#x3E;</button>
        </div>
        <div class="calendar-container">
          <table class="calendar-table">
            <thead>
              <tr>
                <th class="month-header">{{ $t('calendar.month') }}</th>
                <th v-for="day in 31" :key="day" class="day-header">{{ day }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(days, monthKey, index) in calendarData" :key="monthKey">
                <td class="month-label">{{ $t(`calendar.months.${monthKeys[index]}`) }}</td>
                <td v-for="(date, idx) in days" :key="idx"
                :class="{
                  'out-of-month': date.isOutOfMonth,
                  'current-session': date.isInCurrentSession,
                  'selected': date.isSelected,
                  'weekend': date.isWeekend && !date.isInCurrentSession && !date.isSelected,
                  'non-bookable': date.isNonBookable && !(date.isWeekend && (date.isInCurrentSession || date.isSelected)),
                  'clickable': (!date.isNonBookable && !date.isOutOfMonth && !date.isWeekend) || date.isInCurrentSession
                  }"
                  @click="selectDate(date)" :title="date.dayName">
                  <span v-if="date.isSelected">{{ date.isInCurrentSession || date.isSelected ? date.dayName : date.day }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="calendar-legend">
          <div class="legend-item">
            <div class="legend-color disabled"></div>
            <span>{{ $t('calendar.legend_unavailable') }}</span>
          </div>
          <div class="legend-item">
            <div class="legend-color clickable"></div>
            <span>{{ $t('calendar.legend_available') }}</span>
          </div>
          <div class="legend-item">
            <div class="legend-color current-session"></div>
            <span>{{ $t('calendar.legend_current') }}</span>
          </div>
        </div>
        <div v-if="sessionToDelete" style="text-align: right; margin-top: 20px;">
          <b-button class="btnFilter_2" @click="openConfirmDeleteSession">
            {{ sessionIsInProgress ? $t('calendar.stop_session') : $t('calendar.cancel_session') }}
          </b-button>
        </div>
        <div v-if="selectedDate" class="button-group">
          <template v-if="selectedSession">
            <b-button class="btnFilter_2 mx-3" @click="showSessionDetails">
              {{ $t('calendar.session_detail') }}
            </b-button>
          </template>
          <template v-else>
            <b-button class="btnFilter_2 mx-3" @click="confirmReservation">
              {{ $t('calendar.confirm') }}
            </b-button>
            <b-button class="btnFilter_2" @click="cancelReservation">
              {{ $t('calendar.cancel') }}
            </b-button>
          </template>
        </div>
      </div>
    </template>
  </page-outline>
</template>

<script>
import BackButton from "@/components/common/backButton.vue"
import PageOutline from "@/components/common/PageOutline.vue";
import Spinner from "@/components/common/spinner.vue";
import formAccordion from "@/components/common/FormAccordion.vue"
import {errorMessageAlert} from "@/helpers/alert"
import {loadPage} from '@/helpers/routing'

export default {
  name: "BookPage",
  components: {
    "form-accordion": formAccordion,
    BackButton,
    "page-outline": PageOutline,
    spinner: Spinner,
  },
  data() {
    return {
      currentLocale: this.$i18n.locale || 'fr',
      selectedDate: null,
      events: [],
      currentSessionDates: [],
      isPastSession: false,
      selectedSession: null,
      sessionToDelete: null,
      daysInCurrentSession: [],
      hasValidCurrentSession: false,
      sessionIsInProgress: false,
      Books: [],
      daysInMonth: Array.from({ length: 31 }, (_, i) => i + 1),
      monthKeys: [
        "january", "february", "march", "april", "may", "june",
        "july", "august", "september", "october", "november", "december"
      ],
      activeDates: [],
      calendarData: {},
      currentYear: new Date().getFullYear(),
      today: new Date()
    };
  },
  watch: {
    '$i18n.locale'(newLang) {
      this.currentLocale = newLang;
      this.generateCalendar();
    }
  },
  created () {
    this.getAllBookingAndDisableDates();

  },
  methods: {
    formatDateTime(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = this.$t(`calendar.months.${this.monthKeys[date.getMonth()]}`);
      const year = date.getFullYear();

      return `${day} ${month}, ${year}`;
    },
    getAllBookingAndDisableDates(filters = {}) {
      this.$engine.planningTB.getAllBooking(filters)
        .then(resp => {
          const bookings = resp.data.books || [];
          const current = resp.data.sessionEnCours || [];
          //const current = (resp.data.sessionEnCours || []).filter(session => session.UserPhase != 4);
          const now = new Date();

          this.activeDates = bookings.map(session => ({
            start: new Date(session.DateStart),
            end: new Date(session.DateEnd)
          }));

          this.currentSessionDates = current.map(session => ({
            start: new Date(session.DateStart),
            end: new Date(session.DateEnd),
            UserPhase: session.UserPhase
          }));

          this.daysInCurrentSession = [];

          this.currentSessionDates.forEach(session => {
            const start = new Date(session.start.getFullYear(), session.start.getMonth(), session.start.getDate());
            const end = new Date(session.end.getFullYear(), session.end.getMonth(), session.end.getDate());

            let cursor = new Date(start);
            while (cursor <= end) {
              const dateKey = cursor.toISOString().split("T")[0];
              this.daysInCurrentSession.push(dateKey);
              cursor.setDate(cursor.getDate() + 1);
            }
          });

          this.hasValidCurrentSession = this.currentSessionDates.some(session => session.end > now);
          // TROUVER la session à supprimer : en cours ou future
          this.sessionToDelete = null;
          const futureOrCurrentSessions = current.filter(session => {
            const start = new Date(session.DateStart);
            const end = new Date(session.DateEnd);
            const endPlusOne = new Date(end);
            endPlusOne.setDate(endPlusOne.getDate() + 1);
            return endPlusOne >= now && session.UserPhase != 4;
          });
          if (futureOrCurrentSessions.length > 0) {
            this.sessionToDelete = futureOrCurrentSessions[0]; // Prend la première session valide
          }
          if (this.sessionToDelete) {
            const start = new Date(this.sessionToDelete.DateStart);
            const end = new Date(this.sessionToDelete.DateEnd);
            //this.sessionIsInProgress = start <= now && now <= end;
            const endPlusOne = new Date(end);
            endPlusOne.setDate(endPlusOne.getDate() + 1);
            this.sessionIsInProgress = start <= now && now <= endPlusOne;
          } else {
            this.sessionIsInProgress = false;
          }

          this.generateCalendar();
        })
        .catch(error => {
          errorMessageAlert(error, this);
        });
    },
    generateCalendar() {
      this.calendarData = {};
      const weekdays = this.$t('calendar.weekdays_short');
      this.monthKeys.forEach((monthKey, index) => {
        let daysInMonth = new Date(this.currentYear, index + 1, 0).getDate();
        this.calendarData[monthKey] = Array.from({ length: 31 }, (_, day) => {
          let currentDate = new Date(this.currentYear, index, day + 1);
          let dayOfWeek = currentDate.getDay();
          const isOutOfMonth = day + 1 > daysInMonth;
          const isPast = currentDate < new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate());
          const isWeekend = (dayOfWeek === 0 || dayOfWeek === 6) && !isOutOfMonth;

          const dateKey = currentDate.toISOString().split("T")[0];
          const isInCurrentSession = this.daysInCurrentSession.includes(dateKey);

          const isStartDate = this.activeDates.some(d =>
            d.start.getFullYear() === currentDate.getFullYear() &&
            d.start.getMonth() === currentDate.getMonth() &&
            d.start.getDate() === currentDate.getDate()
          );

          let isNonBookable;

          if (this.hasValidCurrentSession) {
            isNonBookable = (!isWeekend && !isOutOfMonth && !isInCurrentSession)
              || (!isWeekend && isPast && !isOutOfMonth && !isInCurrentSession);
          } else {
            isNonBookable = (!isWeekend && !isStartDate && !isOutOfMonth && !isInCurrentSession)
              || (!isWeekend && isPast && !isOutOfMonth && !isInCurrentSession);
          }

          return {
            day: day + 1,
            isOutOfMonth,
            isWeekend,
            isNonBookable,
            isStartDate,
            isSelected: false,
            isInCurrentSession,
            dayName: weekdays[dayOfWeek],
            dateObj: currentDate
          };
        });
      });
    },
    selectDate(date) {
      Object.values(this.calendarData).forEach(month =>
        month.forEach(day => day.isSelected = false)
      );

      const selectedDateObj = date.dateObj;
      const selectedDateClean = new Date(selectedDateObj.getFullYear(), selectedDateObj.getMonth(), selectedDateObj.getDate());
      const todayClean = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate());

      this.selectedDate = null;
      this.selectedSession = null;
      this.isPastSession = false;

      for (let session of this.currentSessionDates) {
        const sessionStart = new Date(session.start.getFullYear(), session.start.getMonth(), session.start.getDate());
        const sessionEnd = new Date(session.end.getFullYear(), session.end.getMonth(), session.end.getDate());

        if (selectedDateClean >= sessionStart && selectedDateClean <= sessionEnd) {
          this.selectedSession = session;
          this.selectedDate = date;
          this.isPastSession = sessionEnd <= todayClean;

          let currentDate = new Date(sessionStart);
          while (currentDate <= sessionEnd) {
            const monthKey = this.monthKeys[currentDate.getMonth()];
            const dayIndex = currentDate.getDate() - 1;
            if (this.calendarData[monthKey] && this.calendarData[monthKey][dayIndex]) {
              const dayObj = this.calendarData[monthKey][dayIndex];
              if (!dayObj.isOutOfMonth) {
                dayObj.isSelected = true;
              }
            }
            currentDate.setDate(currentDate.getDate() + 1);
          }
          return;
        }
      }

      const isBookable = !date.isNonBookable && date.isStartDate && !date.isOutOfMonth && !date.isWeekend;

      if (isBookable) {
        const selectedRange = this.activeDates.find(d =>
          d.start.getFullYear() === this.currentYear &&
          d.start.getMonth() === date.dateObj.getMonth() &&
          d.start.getDate() === date.day
        );

        if (selectedRange) {
          let currentDate = new Date(selectedRange.start);
          while (currentDate <= selectedRange.end) {
            const monthKey = this.monthKeys[currentDate.getMonth()];
            const dayIndex = currentDate.getDate() - 1;
            if (this.calendarData[monthKey] && this.calendarData[monthKey][dayIndex]) {
              const dayObj = this.calendarData[monthKey][dayIndex];
              if (!dayObj.isOutOfMonth) {
                dayObj.isSelected = true;
              }
            }
            currentDate.setDate(currentDate.getDate() + 1);
          }
          this.selectedDate = date;
        }
      }
    },
    confirmReservation() {
      const selectedRange = this.activeDates.find(d =>
        d.start.getFullYear() === this.currentYear &&
        d.start.getMonth() === this.selectedDate.dateObj.getMonth() &&
        d.start.getDate() === this.selectedDate.day
      );

      if (selectedRange) {
        const startDate = selectedRange.start;
        const endDate = selectedRange.end;
        const today = new Date();
        today.setHours(0, 0, 0, 0); // évite les erreurs avec l’heure

        const formatDate = (date) => {
          return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        };

        let dateSlot = formatDate(startDate);
        let dateSlotEnd = formatDate(endDate);
        let params = { dateSlot, dateSlotEnd };

        this.$engine.planningTB.addBooking(params)
          .then(() => {
            const startToday = startDate.toDateString() === today.toDateString();
            const rightsToAdd = ['DDVRequest_ajouter','ExecutionResponder_add'];

            const done = () => {
              this.selectedDate = null;
              this.getAllBookingAndDisableDates();
            };

            const modal = () => {
              this.$f7.modal({
                title: this.$t('common.planningTB_added'),
                text: this.$t('calendar.confirmation', {
                  start: this.formatDateTime(startDate),
                  end: this.formatDateTime(endDate)
                }),
                buttons: [{ text: 'OK', onClick: done }]
              });
            };

            if (startToday) {
              this.$engine.rights.refreshRights(rightsToAdd, []);
              modal();
            } else {
              modal();
            }
          })
          .catch((e) => {
            errorMessageAlert(e, this);
          });
      }
    },
    cancelReservation() {
      if (this.selectedDate) {
        this.selectedDate = null;
        Object.values(this.calendarData).forEach(month =>
          month.forEach(day => day.isSelected = false)
        );
      }
    },
    openConfirmDeleteSession() {
      if (this.sessionToDelete) {
        this.selectedSession = {
          start: new Date(this.sessionToDelete.DateStart),
          end: new Date(this.sessionToDelete.DateEnd)
        };
        this.confirmDeleteSession();
      }
    },
    showSessionDetails() {
      const start = this.formatDateTime(this.selectedSession.start);
      const end = this.formatDateTime(this.selectedSession.end);
      this.$f7.modal({
        title: this.$t('calendar.session_detail'),
        text: this.$t('calendar.session_detail_text', {start,end}),
        buttons: [{ text: 'OK', onClick: () => {
          this.selectedDate = null;
          this.getAllBookingAndDisableDates();
        } }]
      });
    },

    confirmDeleteSession() {
      const start = this.formatDateTime(this.selectedSession.start);
      const end = this.formatDateTime(this.selectedSession.end);

      this.$f7.modal({
        title: this.$t('calendar.delete_title'),
        text: this.$t('calendar.delete_text', {start,end}),
        buttons: [
          { text: this.$t('calendar.supprimer'), onClick: () => this.deleteSession() },
          { text: this.$t('calendar.annuler'), onClick: () => {
            this.selectedDate = null;
            this.getAllBookingAndDisableDates();
          } }
        ]
      });
    },

    deleteSession(filters = {}) {
      const startDate = this.selectedSession.start;
      const endDate = this.selectedSession.end;
      const today = new Date();

      const clean = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
      const start = clean(startDate);
      const end = clean(endDate);
      const todayClean = clean(today);

      const formatDate = (date) => {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      };

      filters.dateSlot = formatDate(startDate);
      filters.dateSlotEnd = formatDate(endDate);

      this.$engine.planningTB.deleteBooking(filters)
        .then(() => {
          const doRefresh = end >= todayClean && start <=todayClean;
          const rightsToDel = ['DDVRequest_ajouter', 'ExecutionResponder_add'];

          const done = () => {
            this.selectedDate = null;
            this.selectedSession = null;
            this.getAllBookingAndDisableDates();
          };

          const modal = () => {
            this.$f7.modal({
              title: this.$t('calendar.delete_success_title'),
              text: this.$t('calendar.delete_success_text'),
              buttons: [{ text: 'OK', onClick: done }]
            });
          };

          if (doRefresh) {
            this.$engine.rights.refreshRights([], rightsToDel);
          }

          modal();
        })
        .catch(e => errorMessageAlert(e, this));
    },
    previousYear() {
      this.currentYear--;
      //this.generateCalendar();
      this.getAllBookingAndDisableDates();
    },
    nextYear() {
      this.currentYear++;
      //this.generateCalendar();
      this.getAllBookingAndDisableDates();
    },
    getDate(date){
      if (date == '' || date == undefined){
        return '-'
      }
      else {
        return moment.utc(date).local().format('DD/MM/YYYY HH:mm:ss')
      }
    },
  },
};
</script>
<style scoped>
/* === Général === */
.container {
  max-width: 2000px;
  margin: auto;
  text-align: center;
  padding: 20px;
}
.current-session-message {
  color: #000;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
}
.calendar-navigation {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  font-size: 20px;
  margin-bottom: 10px;
}
.calendar-container {
  display: block;
  overflow-x: auto;
  max-width: 100%;
  background: #fff;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
/* === Table calendrier === */
.calendar-table {
  border-collapse: collapse;
  min-width: 1000px;
  width: 100%;
}
.calendar-table th,
.calendar-table td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: center;
  min-width: 40px;
  height: 40px;
  transition: all 0.2s ease;
  vertical-align: middle;
}
.calendar-year {
  font-size: 28px !important;
  font-weight: bold;
  margin: 0 10px;
  color: #43A7D4;
}
/* Sticky Headers */
.month-header,
.month-label,
.day-header {
  background: #fff;
  font-weight: bold;
  z-index: 5;
}
.month-header {
  position: sticky;
  color: #000000;
  top: 0;
  left: -12px;
  padding: 10px;
  min-width: 150px;
  max-width: 150px;
  border-right: 2px solid #ddd;
  box-shadow: 3px 0 5px rgba(0, 0, 0, 0.05);
}
.month-label {
  position: sticky;
  color: #000000;
  left: -12px;
  padding-left: 10px;
  min-width: 150px;
  max-width: 150px;
  border-right: 2px solid #ddd;
  box-shadow: 3px 0 5px rgba(0, 0, 0, 0.05);
}
.day-header {
  position: sticky;
  color: #000000;
  top: 0;
  min-width: 40px;
  height: 40px;
}
/* === Cellules === */
.current-session {
  position: relative;
  background-color: #005353 !important;
  color: white !important;
  font-weight: bold;
  overflow: hidden;
}
.current-session::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 200%;
  height: 200%;
  background-image: repeating-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.2),
    rgba(255, 255, 255, 0.2) 4px,
    transparent 4px,
    transparent 8px
  );
  z-index: 1;
}
.weekend,
.out-of-month {
  background-color: #e8e8e8 !important;
  color: #aaa !important;
  pointer-events: none;
}
.non-bookable {
  background-color: #f5f5f5 !important;
  color: #aaa;
  pointer-events: none;
}
.clickable {
  background-color: #0f9898;
  cursor: pointer;
  color: #fff;
  transition: all 0.2s ease;
}
.clickable:hover {
  background-color: #43A7D4;
}
.selected {
  background-color: #43A7D4 !important;
  color: white !important;
  font-weight: bold;
  border-radius: 5px;
}
.selected span {
  font-size: 11px;
  display: inline-block;
  width: 100%;
  text-align: center;
}
/* === Légende === */
.calendar-legend {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 15px;
}
.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.legend-color {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid #ccc;
}
.legend-color.disabled {
  background: linear-gradient(135deg, #f5f5f5 50%, #e0e0e0 50%);
  border: 1px solid #ccc;
  width: 20px;
  height: 20px;
  border-radius: 4px;
}
.legend-color.clickable {
  background-color: #0f9898;
}
/* === Boutons === */
.button-group {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 30px;
}
.button-group .btnFilter_2[disabled] {
  background-color: #ccc !important;
  color: #666 !important;
  border: none;
  cursor: not-allowed;
  opacity: 0.6;
  pointer-events: none;
}
/* === Responsive === */
@media screen and (max-width: 768px) {
  .container {
    padding: 10px;
    max-width: 95vw;
  }
  .calendar-navigation {
    flex-direction: column;
    font-size: 18px;
    gap: 10px;
  }
  .calendar-container {
    padding: 5px;
  }
  .calendar-table {
    min-width: 1000px;
  }
  .calendar-table th,
  .calendar-table td {
    font-size: 12px;
    padding: 5px;
  }
}
</style>
